const config = {
    appVersion: process.env.REACT_APP_VERSION,
    copyright: process.env.REACT_APP_COPYRIGHT,
    baseApiUrl: process.env.REACT_APP_BASE_API_URL
}

export default config;